export default function createGetFormValues(_ref) {
  var getIn = _ref.getIn;
  return function (form, getFormState) {
    return function (state) {
      var nonNullGetFormState = getFormState || function (state) {
        return getIn(state, 'form');
      };

      return getIn(nonNullGetFormState(state), form + ".values");
    };
  };
}


//////////////////
// WEBPACK FOOTER
// ../~/redux-form/es/selectors/getFormValues.js
// module id = 2142
// module chunks = 1